export function formatTimeElapsed(ms: number) {
    const units = [
        {label: "W", value: 1000 * 60 * 60 * 24 * 7},
        {label: "D", value: 1000 * 60 * 60 * 24},
        {label: "H", value: 1000 * 60 * 60}
    ];

    let result = "";

    for (const unit of units) {
        const count = Math.floor(ms / unit.value);
        ms %= unit.value;

        if (count > 0) result += `${count}${unit.label}`;
    }

    return result || "0H" // Defaults to "0H" if nothing is left
}